import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./ChipsInput.css";

const ChipsInput = ({
  value = [],
  placeholder = "Add items...",
  maxChips = 30,
  delimiter = ",",
  onChange,
  isValid = true,
  validateInput,
  style,
  inputStyle,
}) => {
  const [chips, setChips] = useState(value);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setChips(value);
  }, [value]);

  const handleAddChip = () => {
    const trimmedValue = inputValue.trim();
    if (
      trimmedValue &&
      !chips.includes(trimmedValue) &&
      chips.length < maxChips
    ) {
      const newChips = [...chips, trimmedValue];
      setChips(newChips);
      setInputValue("");
      if (onChange) onChange(newChips);
    }
  };

  const handleRemoveChip = (index) => {
    const newChips = chips.filter((_, i) => i !== index);
    setChips(newChips);
    if (onChange) onChange(newChips);
  };

  const handleKeyDown = (event) => {
    if ((event.key === "Enter" || event.key === delimiter) && isValid) {
      event.preventDefault();
      handleAddChip();
    }
  };

  const handleInputChange = (event) => {
    if (typeof validateInput == "function") {
      validateInput(event?.target?.value?.trim());
    }
    setInputValue(event?.target?.value?.trim());
  };

  return (
    <div className="form__input form__input--sm chips-input-container" style={style}>
      <div className="chips-display">
        {chips.map((chip, index) => (
          <div key={index} className="chip">
            {chip}
            <button
              type="button"
              className="chip-remove-button"
              onClick={() => handleRemoveChip(index)}
            >
              &times;
            </button>
          </div>
        ))}
        <input
          className="chips-input"
          type="text"
          value={inputValue}
          placeholder={placeholder}
          style={inputStyle}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
      </div>
    </div>
  );
};

ChipsInput.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
  maxChips: PropTypes.number,
  delimiter: PropTypes.string,
  onChange: PropTypes.func,
};

export default ChipsInput;
